import { Fragment } from 'react'
import { GetStaticProps, GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import TutorOnDemandFinance from '~/tutor-on-demand/pages/TutorOnDemandFinance.page'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import SubjectMetatags, { SubjectType } from '~/components/Metadata/SubjectMetatags'

const TutorOnDemandFinancePage: NextPage = () => {
  const { t } = useTranslation('tutorOnDemandFinance')
  const title = t('title')

  return (
    <Fragment>
      <SubjectMetatags metaDescription={t('metaDescription')} title={title} type={SubjectType.FINANCE} />

      <DefaultLayout zeroPadding>
        <TutorOnDemandFinance type={SubjectType.FINANCE} />
      </DefaultLayout>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'tutorOnDemand',
      'tutorOnDemandFinance',
    ])),
  },
})

export default TutorOnDemandFinancePage
